import React from "react";
import ToolTip from "../tooltip";

const OnboardingRadio = ({
  label = "User Reference",
  onClick,
  options = defaultOptions,
  value,
  name,
  tooltipText = "",
}) => {
  return (
    <div className="radio-container">
      {label && <label htmlFor={name}>{label}</label>}
      <div>
        {options.map((option) => (
          <button
            onClick={(e) => {
              onClick(option.value);
            }}
            key={option.label}
            data-button-type={option.value === value ? "outline" : "text-white"}
            type="button"
          >
            <input
              id="metric-radio"
              type="radio"
              name={name}
              defaultChecked={option.defaultChecked}
              defaultValue={option.value}
            />
            <span>{option.label}</span>
          </button>
        ))}

        {tooltipText ? (
          <ToolTip id={name} body={tooltipText} place="bottom" float={false}>
            <span className="bg-(--secondary-background-color) ml-1 p-1 px-2 rounded-full">
              ?
            </span>
          </ToolTip>
        ) : (
          <span className="opacity-0 no-opacity" />
        )}
      </div>
    </div>
  );
};

export default OnboardingRadio;
